exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n@media (max-width: 425px) {\n    .headerContainer__columnHeader-module___KwGR2 {\n    font-size: 10px;\n}\n}\n", ""]);

// Exports
exports.locals = {
	"headerContainer": "headerContainer__columnHeader-module___KwGR2"
};